var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dot-list details-list text-left"},_vm._l((_vm.items),function(item,index){return _c('li',{key:'item' + index},[_vm._t("default",function(){return [_c('div',{staticClass:"dot-list__item",domProps:{"innerHTML":_vm._s(item)}})]},{"item":item,"index":index})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }